<template>
  <div id="top-header">
    <dv-decoration-8 class="header-left-decoration" />
    <dv-decoration-5 class="header-center-decoration" />
    <dv-decoration-8 class="header-right-decoration" :reverse="true" />
    <div class="center-title" @click="toggleFullScreen">{{ storeName }}</div>
    <div class="currentDate">{{ currentDate }} {{ Weekday }}</div>
    <div class="currentWeather">{{ weather.temperature }}°C {{ weather.weather }}</div>
  </div>
</template>

<script>
export default {
  name: 'TopHeader',
  props: {
    storeName: {
      type: String,
      default: ''
    },
    currentDate: {
      type: String,
      default: ''
    },
    Weekday: {
      type: String,
      default: ''
    },
    weather: {
      type: Object,
      default: () => ({})
    },
    toggleFullScreen: {
      type: Function,
      default: () => {}
    }
  },
  methods: {
    toggleFullScreen() {
      this.$emit('toggleFullScreen');
    }
  }
}
</script>

<style lang="scss" scoped>
#top-header {
  position: relative;
  width: 100%;
  height: 100px;
  display: flex;
  justify-content: space-between;
  flex-shrink: 0;

  .header-center-decoration {
    width: 40%;
    height: 60px;
    margin-top: 30px;
  }

  .header-left-decoration, .header-right-decoration {
    width: 25%;
    height: 60px;
  }

  .center-title {
    position: absolute;
    font-size: 30px;
    font-weight: bold;
    left: 50%;
    top: 15px;
    transform: translateX(-50%);
  }
  .currentDate {
    font-size: 20px;
    color: #fff;
    position: absolute;
    left: 18.5%;
    top: 50px;
    transform: translateX(-50%);
  }
  .currentWeather {
    font-size: 20px;
    color: #fff;
    position: absolute;
    right: 13%;
    top: 50px;
  }
}
</style>
